import { BaseApi } from './BaseApi';
export class IdwDbApi extends BaseApi {
    constructor(config) {
        super(config);
    }
    isDbExist() {
        return this.providers.makeRequest({
            route: this.buildRoute('db'),
            method: 'GET',
        });
    }
    prepareDb() {
        return this.providers.makeRequest({
            route: this.buildRoute('db'),
            method: 'POST',
        });
    }
}
//# sourceMappingURL=idwDbApi.js.map